import { render, staticRenderFns } from "./attachmentCard.vue?vue&type=template&id=6fbe70ae"
import script from "./attachmentCard.vue?vue&type=script&lang=ts"
export * from "./attachmentCard.vue?vue&type=script&lang=ts"
import style0 from "./attachmentCard.vue?vue&type=style&index=0&id=6fbe70ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports